import React from 'react';
import {backEndUri} from '../../config';
import NeedAdmin from "../NeedAdmin";
import {FormattedMessage} from "react-intl";

export default function PhotoboothCellStatsButton({cell}){
    return(
        <NeedAdmin trueAdmin>
            <a
                href={`${backEndUri}/photo/${cell.id}/stats`}
                download
                style={{
                display: 'inline-block',
                padding: '0.5em 1em',
                textAlign: 'center',
                textDecoration: 'none',
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #ccc',
                borderRadius: '4px',
                cursor: 'pointer'
                }}
                className="tsk-upper"
            >
                <FormattedMessage id="projects.stats.button" />
            </a>
        </NeedAdmin>
    );
}
